<template>
  <div id="dashboard-settings">
    <div class="container">
      <h1>Settings</h1>
      <hr>
      <h2>Update Email Address</h2>
      <form @submit.prevent>
        <div class="form-group">
          <label>Email</label>
          <input class="form-control" v-model="newEmail" :placeholder="currentUser.email" />
        </div><!-- /.form-group -->
        <button class="btn btn-outline-primary" @click="updateEmail()">Update Email</button>
      </form>
      <hr>
      <h2>Update Password</h2>
      <form @submit.prevent>
        <div class="form-group">
          <label>New Password</label>
          <input class="form-control" v-model="newPassword" type="password" placeholder="******" />
        </div><!-- /.form-group -->
        <button class="btn btn-outline-primary" @click="updatePassword()">Update Password</button>
      </form>
      <hr>
      <button class="btn btn-outline-warning" @click="logout()"><i class="fal fa-sign-out"></i> Log out</button>
    </div><!-- /.container -->
  </div><!-- /#dashboard-settings -->
</template>

<script>
  import { mapState } from 'vuex'
  const fb = require('../firebaseConfig.js')

  export default {
    data() {
      return {
        newPassword: '',
        newEmail: ''
      }
    },
    computed: {
      ...mapState(['userProfile', 'currentUser'])
    },
    methods: {
      updateEmail() {
        let self = this
        fb.auth.currentUser.updateEmail(this.newEmail).then(function(){
          //Do something
          alert('Successfully updated your email!')
          self.newEmail = ''
        }).catch(function(err){
          //Do something
          alert(err.message)
        })
      },
      updatePassword() {
        let self = this
        fb.auth.currentUser.updatePassword(this.newPassword).then(function(){
          //Do something
          alert('Successfully updated your password!')
          self.newPassword = ''
        }).catch(function(err){
          //Do something
          alert(err.message)
        })
      },
      logout() {
        fb.auth.signOut().then(() => {
          this.$store.dispatch('clearData')
          this.$router.push({name: 'Login'})
        }).catch(err => {
          console.log(err)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/DashboardSettings.vue